import Div from 'components/Div';
import { getOrderContext } from 'contexts/order';
import React from 'react';
import styled from 'styled-components';
import { deepEqual, formatNumber } from 'utils/vanillaFunctions';
import { FaCartPlus, FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { AiFillCloseSquare } from 'react-icons/ai';
import { NotificationManager } from 'react-notifications';
import Req from 'utils/Request';
import { FaMinusCircle, FaPlusCircle } from 'react-icons/fa';

const Cart = () => {
    const [toggled, setToggled] = React.useState(true);
    const { menus, setMenus, setCheckoutInfo, address, custPhone, discount, setSuggestedDiscount } = React.useContext(getOrderContext);

    const [timeoutId2, setTimeoutId2] = React.useState();
    const checkDuplicate = () => {
        const clonedMenu = [...menus];
        const clonedItem = { ...clonedMenu[clonedMenu.length - 1] };
        clonedMenu.pop();
        clonedMenu.forEach((menu, index) => {
            const isEqual = deepEqual({ ...menu, count: null }, { ...clonedItem, count: null });
            if (isEqual) {
                const storeCount = menu.count ?? 1;
                delete menu.count;
                clonedMenu[index] = {
                    ...menu,
                    count: storeCount + 1,
                };
                setMenus(clonedMenu);
            }
        });
    };
    const handleRemove = (index) => {
        const clonedMenu = [...menus];
        clonedMenu.splice(index, 1);
        setMenus(clonedMenu);
    };

    const handlePlus = (index) => {
        const clonedMenu = [...menus];
        clonedMenu[index] = { ...clonedMenu[index], count: (clonedMenu[index].count ?? 1) + 1 };
        setMenus(clonedMenu);
    };

    const handleMinus = (index) => {
        const clonedMenu = [...menus];
        clonedMenu[index] = { ...clonedMenu[index], count: (clonedMenu[index].count ?? 1) - 1 };
        setMenus(clonedMenu);
    };

    const debounce = (fn, delay, timeout, settimeout) => {
        return function (...args) {
            clearTimeout(timeout);
            settimeout(
                setTimeout(() => {
                    fn.apply(this, args);
                }, delay)
            );
        };
    };
    const handleCheckout = async () => {
        const clonedMenu = [...menus];
        clonedMenu.forEach((menu, i) => {
            if (!menu.count) clonedMenu[i].count = 1;
        });
        const orderObject = {
            storeName: address.storeName,
            orderType: address.haveDelivery ? 'delivery' : 'pickup',
            orderDate: address.date,
        };
        if (address.haveDelivery === 'delivery') orderObject.podCode = address.detail.podph;
        if (discount?.code) orderObject.discount = { code: discount.code };

        let addressObject = null;
        if (address.haveDelivery) {
            addressObject = { ...address.detail };
            addressObject.ortsKod = address.ortsKod;
            addressObject.orts = address.orts;
            addressObject.haalga = address.haalga;
            addressObject.additional = address.additional;
        }
        const custObject = {
            phone: custPhone,
        };
        const bodyObject = { order: { ...orderObject }, cust: { ...custObject } };

        // IF DELIVERY TRUE, INJECT ADDRESS
        if (addressObject) bodyObject.address = { ...addressObject };

        // INJECT CART PRODUCTS MENU
        bodyObject.menus = [...menus];
        try {
            // const result = await Req({ url: '/order/checkout', body: bodyObject, hideSuccess: true, hideError: true });
            const result = await Req({ url: '/order/checkoutOrder', body: bodyObject, hideSuccess: true, hideError: true });
            setCheckoutInfo(result.data.data.totals);
            setSuggestedDiscount(result.data.data.suggestedDiscount || null);
        } catch (e) {
            NotificationManager.warning(e, '', 10000);
            setCheckoutInfo(null);
        }
    };
    React.useEffect(() => {
        if (menus.length) {
            checkDuplicate();

            // debounce(toastMessage, 200, timeoutId, setTimeoutId)();
            debounce(handleCheckout, 200, timeoutId2, setTimeoutId2)();
        } else {
            setCheckoutInfo(null);
        }
    }, [menus]);

    const isFirstDiscount = React.useRef(true);
    React.useEffect(() => {
        // Re-run checkout when the operator changes the selected discount
        if (isFirstDiscount.current) {
            isFirstDiscount.current = false;
            return;
        }
        if (menus.length) {
            debounce(handleCheckout, 200, timeoutId2, setTimeoutId2)();
        }
    }, [discount]);

    return (
        <Container id="cartWrap">
            <Div c="toggle" onClick={() => setToggled(!toggled)}>
                <FaCartPlus />
                <span>Бүтээгдэхүүн</span>
                {toggled ? <FaChevronDown className="chevron" /> : <FaChevronRight className="chevron" />}
            </Div>
            {toggled ? (
                <Div c="content">
                    {menus.map((menu, index) => (
                        <Div key={index}>
                            <Div c="menuWrap">
                                <span className="name">
                                    {menu.type === 'pizza' ? `${menu.masterName}` : (menu.name || menu.masterName)} (
                                    {menu.count}ш)
                                </span>
                                <div className="right">
                                    <div className="action">
                                        <button disabled={menus[index]?.count === 1} onClick={() => handleMinus(index)}>
                                            <FaMinusCircle size={13} color="#C0C0C0" />
                                        </button>
                                        <span className="count">{menu.count ?? 1}</span>
                                        <button onClick={() => handlePlus(index)}>
                                            <FaPlusCircle size={13} color="#C0C0C0" />
                                        </button>
                                    </div>
                                    <span className="count">
                                        {formatNumber((menu.price ?? menu.defaultPrice) * (menu.count ?? 1))}₮
                                        <AiFillCloseSquare onClick={() => handleRemove(index)} />
                                    </span>
                                </div>
                            </Div>
                            <Div c="submenu">
                                {menu.comboMainItems ? (
                                    <span className="name">
                                        -
                                        {menu.comboMainItems.type === 'pizza'
                                            ? `${menu?.comboMainItems?.masterName}`
                                            : (menu?.comboMainItems?.name || menu?.comboMainItems?.masterName)}{' '}
                                        ({menu.comboMainItems?.price}₮)
                                    </span>
                                ) : (
                                    ''
                                )}
                                {menu.comboSideItems
                                    ? menu.comboSideItems.map((sideItem, index) => (
                                        <span className="name" key={index}>
                                            {/* -{sideItem.type === 'single' ? } */}-
                                            {sideItem.type === 'pizza'
                                                //   ? `${getTranslation(sideItem.pizzaSize)} ${getTranslation(sideItem.pizzaBase)} ${getTranslation(sideItem.name)}`
                                                //   : getTranslation(sideItem?.masterName)}{' '}
                                                ? `${sideItem?.masterName}`
                                                : (sideItem?.name || sideItem?.masterName)}{' '}
                                            ({sideItem?.price}₮)
                                        </span>
                                    ))
                                    : ''}
                            </Div>
                        </Div>
                    ))}
                </Div>
            ) : (
                ''
            )}
        </Container>
    );
};

export default Cart;

const Container = styled.div`
    .toggle {
        cursor: pointer;
        background: ${({ theme }) => theme.color};
        color: white;
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 8px 8px;
        font-size: 14px;
        border-radius: 4px;
        .chevron {
            margin-left: auto;
        }
        margin-bottom: 10px;
    }
    .content {
        .menuWrap {
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            gap: 10px;
            .name {
                font-weight: 500;
                flex-basis: 110px;
            }
            .right {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-grow: 1;
                .action {
                    display: flex;
                    gap: 5px;
                }
                .count {
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    svg {
                        font-size: 20px;
                        color: ${({ theme }) => theme.color};
                        margin-top: -1px;
                        cursor: pointer;
                    }
                }
            }
        }
        .submenu {
            display: flex;
            flex-direction: column;
            padding-left: 10px;
            margin-bottom: 10px;
            color: gray;
            .name {
                margin-bottom: 2px;
            }
        }
    }
`;
